import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsRetroarchComponent } from './simple-icons-retroarch.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsRetroarchComponent ],
    exports:      [ SimpleIconsRetroarchComponent ],
    bootstrap:    []
})
export class SimpleIconsRetroarchModule {}
